// extracted by mini-css-extract-plugin
module.exports = {"loader":"GenerateEnvelopeModal_loader__00EgT","backLink":"GenerateEnvelopeModal_backLink__r8Ean","title":"GenerateEnvelopeModal_title__m77_a"};